<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h1>Acceso</h1>
                <p class="text-muted">Ingrese a su cuenta</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon">
                    <i class="icon-user"></i>
                  </span>
                  <input
                    v-model="usuario.user"
                    type="text"
                    class="form-control"
                    placeholder="Usuario"
                  >
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon">
                    <i class="icon-lock"></i>
                  </span>
                  <input
                    v-model="usuario.password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                  >
                </div>
                <div class="row">
                  <div class="col-6">
                    <button @click="send_login" type="button" class="btn btn-primary px-4">Ingresar</button>
                  </div>
                  <div class="col-6 text-right">
                    <!--   <button   type="button" class="btn btn-link px-0">Forgot password?</button>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <!-- <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <button type="button" class="btn btn-primary active mt-3">Register Now!</button>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { url } from "../../main.js";
export default {
  data() {
    return {
      usuario: {
        user: "",
        password: ""
      },

      error: ""
    };
  },
  methods: {
    send_login() {
      if (this.usuario.user != "" && this.usuario.password != "") {
        this.axios
          .post(
            url+"apiUsers.php/login",
            this.usuario
          )
          .then(respuesta => {
            console.log(respuesta);
            if (respuesta.data != null) {
              localStorage.setItem('iduser',respuesta.data.iduser);
              localStorage.setItem('username', respuesta.data.nombre);
              localStorage.setItem('permission', respuesta.data.permission);
              this.$router.push("/main");

            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.error = "Ingrese usuario y contraseña";
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/views/pages/Login.vue